module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "Slide"
  }, [_c('article', [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "PostSlider"
  }, _vm._l((_vm.posts), function(post) {
    return _c('li', [_c('post', {
      attrs: {
        "post": post
      }
    })], 1)
  })), _vm._v(" "), _c('a', {
    staticClass: "toBlog",
    attrs: {
      "href": _vm.home_url + 'blog/'
    }
  }, [_vm._v("≫ ブログ一覧を見る")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('p', [_c('img', {
    attrs: {
      "src": require("../assets/images/top/img_blog-header.svg"),
      "alt": "おやこハグ日記"
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("おやこハグネットは、"), _c('br', {
    staticClass: "visible-sp"
  }), _vm._v("日々様々な活動を行っています。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-33e2af88!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/BlogSlide.vue
// module id = 380
// module chunks = 2